module.exports = __webpack_public_path__ + "static/media/pink_pin.3063ca8a.svg";